/*
 * 8席を楕円状に配置する。
 *
 * 固定 px を使わず、卓の短辺に対する割合で組む。中央端末の画面サイズが変わっても
 * 配置と文字の関係が崩れない（要件11.9）。
 */

/*
 * 卓は与えられた高さに収まる大きさへ自分を合わせる。
 *
 * 幅から高さを決める（width:100% + aspect-ratio）と、画面が横長なときに卓が縦へ
 * はみ出す。中央ディスプレイはスクロールしない前提なので、高さを基準にして幅を導く。
 * 横幅が足りない場合だけ max-width で幅基準へ切り替わる。
 */
.table {
  position: relative;
  height: 100%;
  /* 卓の縦横比。横長の中央ディスプレイを前提にする。 */
  aspect-ratio: 16 / 10;
  width: auto;
  max-width: 100%;
  margin-inline: auto;
  border-radius: 50%;
  background: radial-gradient(
    ellipse at center,
    var(--mantine-color-teal-9) 0%,
    var(--mantine-color-dark-7) 78%
  );
  box-shadow: inset 0 0 0 0.5rem var(--mantine-color-dark-5);
}

/*
 * 卓の中央。ボードの枚数とポット総額をここへまとめる。
 *
 * ボードを独立配置にすると、真上の席（席5）のベット額チップと重なる。ベットチップは
 * 席と中心の間に置かれるため、中央から離すほど席側の表示とぶつかる。中央ブロックに
 * 入れておけば重なりが構造的に起きない。
 *
 * ボードは枚数によらず常に5枠を描くので、ストリートが変わってもこのブロックの高さは
 * 変わらない。ポット総額の縦位置はずれない。
 */
.center {
  position: absolute;
  inset: 50% auto auto 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 56%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
}

.seat {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 10rem;
}

.seatCard {
  border-width: 0.1875rem;
  transition:
    border-color 120ms ease,
    box-shadow 120ms ease,
    transform 120ms ease;
}

/*
 * 現在アクション権を持つ席を強調する（要件11.4）。
 *
 * 背景を塗りつぶすのではなく、枠と外側の光で示す。塗りつぶすと席番号などの小さな文字が
 * 背景に沈んで読めなくなり、いちばん読ませたいカードの可読性が落ちる。ベット額のチップも
 * 黄色なので、面で黄色を使うと区別しにくくなる。
 */
.turn {
  border-color: var(--mantine-color-yellow-4);
  box-shadow:
    0 0 0 0.28rem rgb(250 204 21 / 32%),
    0 0 1.8rem rgb(250 204 21 / 45%);
  transform: scale(1.05);
}

/*
 * 参加していない席は控えめにするが、読めなくはしない。名前とスタックは卓から確認する
 * 対象なので、薄くしすぎると意味が無くなる。
 */
.folded {
  opacity: 0.62;
}

.empty {
  opacity: 0.8;
  border-style: dashed;
}

.button {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
}

/* ベット額のチップ。席カードと違って幅は内容に任せる。 */
.bet {
  position: absolute;
  transform: translate(-50%, -50%);
}
